'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applyQueriesToFirebaseRef = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _lodash = require('lodash');

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var Subscription = function () {
  // onUpdate: (any) => void
  function Subscription(database, query, deregisterCallback) {
    _classCallCheck(this, Subscription);

    this.loaded = false;
    this.listeners = {};
    this.listening = false;
    this.query = query;
    var ref = query.ref,
        queries = query.queries;
    this.ref = queries ? applyQueriesToFirebaseRef(queries, database.ref(ref)) : database.ref(ref);

    if (deregisterCallback) {
      this.deregisterCallback = deregisterCallback;
    }
  }

  _createClass(Subscription, [{
    key: 'listen',
    value: function listen(callback) {
      var _this = this;

      if ((0, _lodash.size)(this.listeners) === 0 && !this.listening) {
        this.listening = true;
        this.ref.on(this.query.event || 'value', this.handleUpdate, this);
      }

      var requestId = (0, _v2.default)();
      this.listeners[requestId] = callback;
      return {
        value: this.data,
        loading: !this.loaded,
        unsubscribe: function unsubscribe() {
          return _this.unsubscribe(requestId);
        }
      };
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe(requestId) {
      this.listeners[requestId] && delete this.listeners[requestId];

      if ((0, _lodash.size)(this.listeners) === 0) {
        this.destroy();
      }
    }
  }, {
    key: 'handleUpdate',
    value: function handleUpdate(snapshot) {
      var data = snapshot.val();
      this.data = data;
      this.loaded = true; // console.log("Subscription complete", this.query, this.listeners)

      (0, _lodash.forEach)(this.listeners, function (listener) {
        return listener(data);
      });
    }
  }, {
    key: 'destroy',
    value: function destroy(force) {
      if (this.query.permanent && !force) {
        return;
      }

      this.listeners = {};
      this.loaded = false;

      if (this.listening) {
        this.listening = false;
        this.ref.off(this.query.event || 'value', this.handleUpdate, this);
      }

      this.deregisterCallback && this.deregisterCallback();
    }
  }]);

  return Subscription;
}();

exports.default = Subscription;

var noArgs = function noArgs() {
  return [];
};

var asIs = function asIs(v) {
  return [v];
};

var customQueryArgumentTransformers = {
  orderByKey: noArgs,
  orderByPriority: noArgs,
  orderByValue: noArgs
};

var applyQueriesToFirebaseRef = exports.applyQueriesToFirebaseRef = function applyQueriesToFirebaseRef(queries, ref) {
  return (0, _lodash.reduce)(queries, function (ref, value, field) {
    if (ref[field]) {
      var transformer = customQueryArgumentTransformers[field] || asIs;
      return ref[field].apply(ref, _toConsumableArray(transformer(value)));
    } else {
      throw new Error('Invalid Firebase query field ' + field);
    }
  }, ref);
};